import React from 'react';
import { Grid, Typography, Fab } from '@material-ui/core';
import { Link } from 'react-router-dom';
import { Add as AddIcon } from '@material-ui/icons';


interface IProps {
    title: React.ReactNode | string
    subtitle?: React.ReactNode | string
    addNewUrl?: string
}

let PageHeader = ({ title, subtitle, addNewUrl }: IProps) => {

    return (
        <Grid container alignItems="flex-end">
            <Grid item xs>
                {React.isValidElement(title) && title}
                {React.isValidElement(title) === false && <Typography variant="h4">{title}</Typography>}
                {subtitle &&
                    <>
                        {React.isValidElement(subtitle) && subtitle}
                        {React.isValidElement(subtitle) === false && <Typography variant="h5">{subtitle}</Typography>}
                    </>
                }
            </Grid>
            {addNewUrl &&
                <Grid item>
                    <Fab
                        color="primary"
                        variant="extended"
                        component={Link}
                        to={addNewUrl}
                    >
                        <AddIcon />&nbsp;Add new
                    </Fab>
                </Grid>
            }
        </Grid>
    );
}

export default PageHeader;